import { render, staticRenderFns } from "./positioning-device-fittings-type-add-processremark-modal.vue?vue&type=template&id=6dae7730"
import script from "./positioning-device-fittings-type-add-processremark-modal.vue?vue&type=script&lang=js"
export * from "./positioning-device-fittings-type-add-processremark-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports